// https://github.com/ffmpegwasm/ffmpeg.wasm
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile, toBlobURL } from "@ffmpeg/util";
// const baseURL = 'https://unpkg.com/@ffmpeg/core-mt@0.12.6/dist/esm';
// const baseURL = './static/js/ffmpeg';
import GlobalConfig from '@/config/config.js'
import { replaceFileExtension } from '@/utils/tools.js'
const ffmpegURL = `${GlobalConfig.baseAssetsUrl}/static/js/ffmpegMini20240511`;
const loadFfmpegTimeout = 1000 * 60;
const transFileToWav = (file, fileName = "output.wav") => {
  // console.log("transMovFileToWav 开始加载")
  return new Promise(async (resolve, reject) => {
    let ffmpeg;
    const timer = setTimeout(() => {
      reject(new Error('FFmpeg loading timed out'));
      ffmpeg.off();
      ffmpeg = null;
    }, loadFfmpegTimeout);
    try {
      ffmpeg = new FFmpeg();
      ffmpeg.on("log", ({ message }) => {
        console.log(message);
      });


      await ffmpeg.load({
        coreURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.js`,
          "text/javascript"
        ),
        wasmURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.wasm`,
          "application/wasm"
        ),
        workerURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.worker.js`,
          "text/javascript"
        ),
      })
      clearTimeout(timer);
      // console.log("transMovFileToWav 加载OK")
      // console.log("transMovFileToWav 开始写文件")
      await ffmpeg.writeFile(replaceFileExtension(file.name), await fetchFile(file));
      // console.log("transMovFileToWav 开始转换")
      await ffmpeg.exec(["-i", replaceFileExtension(file.name), "-vn", fileName]);
      // console.log("transMovFileToWav 读取转换结果")
      const data = await ffmpeg.readFile(fileName);
      console.log(data);
      // console.log("transMovFileToWav 转换后的数据长度", data.length)
      const blobUrl = (window.URL || window.webkitURL).createObjectURL(
        new Blob([data.buffer], { type: "audio/wav" })
      );
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      // 创建 File 对象
      const resfile = new File([blob], fileName, { type: blob.type });
      // console.log("transMovFileToWav 生成文件")
      // const resfile = new File([data], fileName, { type: 'audio/wav' });
      const res = {
        file: resfile,
        blobUrl: blobUrl,
        blob: blob
      };
      // console.log("transMovFileToWav 转换完成", res)
      resolve(res);
      ffmpeg.off();
      ffmpeg = null;
    } catch (e) {
      clearTimeout(timer);
      ffmpeg.off();
      ffmpeg = null;
      reject(e);
    }
  });
};

const transFileToMp3 = (file, fileName = "output.mp3") => {
  // console.log("transMovFileToWav 开始加载")
  return new Promise(async (resolve, reject) => {
    let ffmpeg;
    const timer = setTimeout(() => {

      reject(new Error('FFmpeg loading timed out'));
      ffmpeg.off();
      ffmpeg = null;
    }, loadFfmpegTimeout);
    try {
      ffmpeg = new FFmpeg();
      ffmpeg.on("log", ({ message }) => {
        console.log(message);
      });
      await ffmpeg.load({
        coreURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.js`,
          "text/javascript"
        ),
        wasmURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.wasm`,
          "application/wasm"
        ),
        workerURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.worker.js`,
          "text/javascript"
        ),
      });
      clearTimeout(timer);
      // console.log("transMovFileToWav 加载OK")
      // console.log("transMovFileToWav 开始写文件")
      // await ffmpeg.exec(["-codecs"]);
      await ffmpeg.writeFile(replaceFileExtension(file.name), await fetchFile(file));
      // console.log("transMovFileToWav 开始转换")
      await ffmpeg.exec([
        "-i",
        replaceFileExtension(file.name),
        "-c:a",
        "libmp3lame",
        "-q:a",
        2,
        fileName,
      ]);
      // console.log("transMovFileToWav 读取转换结果")

      const data = await ffmpeg.readFile(fileName);
      console.log(data);
      // console.log("transMovFileToWav 转换后的数据长度", data?.length)
      const blobUrl = (window.URL || window.webkitURL).createObjectURL(
        new Blob([data.buffer], { type: "audio/mp3" })
      );
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      // 创建 File 对象
      const resfile = new File([blob], fileName, { type: blob.type });

      // console.log("transMovFileToWav 生成文件")
      // const resfile = new File([data], fileName, { type: 'audio/wav' });
      ffmpeg.off();
      ffmpeg = null;
      if (!resfile.size && file.size) {
        reject("转换失败，生成的文件大小为0");
        return;
      }
      const res = {
        file: resfile,
        blobUrl: blobUrl,
        blob: blob
      };
      // console.log("transMovFileToWav 转换完成", res)
      resolve(res);

    } catch (e) {
      clearTimeout(timer);
      reject(e);
      ffmpeg.off();
      ffmpeg = null;
    }
  });
};

const transFileByFfmpeg = async (
  file,
  fileName = "output.wav",
  extendOrder = []
) => {
  // console.log("transMovFileToWav 开始加载")
  return new Promise(async (resolve, reject) => {
    let ffmpeg;
    const timer = setTimeout(() => {
      reject(new Error('FFmpeg loading timed out'));
      ffmpeg.off();
      ffmpeg = null;
    }, loadFfmpegTimeout);
    try {
      ffmpeg = new FFmpeg();
      ffmpeg.on("log", ({ message }) => {
        console.log(message);
      });
      await ffmpeg.load({
        coreURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.js`,
          "text/javascript"
        ),
        wasmURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.wasm`,
          "application/wasm"
        ),
        workerURL: await toBlobURL(
          `${ffmpegURL}/ffmpeg-core.worker.js`,
          "text/javascript"
        ),
      });
      // console.log("transMovFileToWav 加载OK")
      // console.log("transMovFileToWav 开始写文件")
      await ffmpeg.writeFile(replaceFileExtension(file.name), await fetchFile(file));
      // console.log("transMovFileToWav 开始转换")
      await ffmpeg.exec(["-i", replaceFileExtension(file.name), ...extendOrder.concat([fileName])]);
      // console.log("transMovFileToWav 读取转换结果")
      const data = await ffmpeg.readFile(fileName);
      console.log(data);
      // console.log("transMovFileToWav 转换后的数据长度", data.length)
      const blobUrl = (window.URL || window.webkitURL).createObjectURL(
        new Blob([data.buffer], { type: "audio/wav" })
      );
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      // 创建 File 对象
      const resfile = new File([blob], fileName, { type: blob.type });
      // console.log("transMovFileToWav 生成文件")
      // const resfile = new File([data], fileName, { type: 'audio/wav' });
      const res = {
        file: resfile,
        blobUrl: blobUrl,
        blob: blob
      };
      // console.log("transMovFileToWav 转换完成", res)
      resolve(res);
      ffmpeg.off();
      ffmpeg = null;
    } catch (e) {
      ffmpeg.off();
      ffmpeg = null;
      reject(e);
    }
  });
};

export default {
  transFileToWav,
  transFileToMp3,
  transFileByFfmpeg,
};



/*
FFmpeg 是一个强大的音视频处理工具，以下是一些常用的命令分类整理，适合日常操作：

1. 视频转换格式
bash
复制
ffmpeg -i input.mp4 output.avi
ffmpeg -i input.mkv -c:v libx264 -c:a aac output.mp4  # 转MP4并指定编码
2. 提取音频/视频
bash
复制
ffmpeg -i input.mp4 -vn -c:a copy output.aac         # 提取音频（保留原编码）
ffmpeg -i input.mp4 -an output_video_only.mp4       # 去除音频
ffmpeg -i input.mp4 -c:v copy -an output_no_audio.mp4 # 去除音频（快速）
3. 调整分辨率/帧率/比特率
bash
复制
ffmpeg -i input.mp4 -s 1280x720 -c:a copy output.mp4  # 修改分辨率
ffmpeg -i input.mp4 -r 30 -c:a copy output.mp4       # 修改帧率为30fps
ffmpeg -i input.mp4 -b:v 1M -b:a 128k output.mp4     # 设置视频/音频比特率
4. 裁剪/截取视频
bash
复制
ffmpeg -i input.mp4 -ss 00:01:30 -t 10 -c copy output.mp4  # 从1分30秒截取10秒
ffmpeg -i input.mp4 -vf "crop=w:h:x:y" output.mp4         # 裁剪画面（w:宽度, h:高度, x/y:起点）
5. 合并视频/音频
bash
复制
ffmpeg -i video.mp4 -i audio.mp3 -c:v copy -c:a aac -strict experimental output.mp4  # 合并音视频
ffmpeg -f concat -i filelist.txt -c copy output.mp4      # 合并多个视频（需文本列表）
6. 添加水印/字幕
bash
复制
ffmpeg -i input.mp4 -i logo.png -filter_complex "overlay=10:10" output.mp4  # 添加图片水印
ffmpeg -i input.mp4 -vf "drawtext=text='Hello':x=10:y=10:fontsize=24:color=white" output.mp4  # 文字水印
ffmpeg -i input.mp4 -vf subtitles=sub.srt output.mp4    # 添加字幕
7. 屏幕录制
bash
复制
ffmpeg -f avfoundation -i "1:0" -r 30 output.mp4        # Mac录屏（1为设备号）
ffmpeg -f gdigrab -i desktop -r 30 output.mp4          # Windows录屏
8. 直播推流
bash
复制
ffmpeg -re -i input.mp4 -c:v libx264 -preset fast -f flv rtmp://server/live/stream_key
9. 压缩视频
bash
复制
ffmpeg -i input.mp4 -c:v libx264 -crf 23 -preset medium -c:a aac -b:a 128k output.mp4
# -crf 值越小质量越高（18-28合理），-preset 控制速度（ultrafast/slow等）
10. 提取关键帧
bash
复制
ffmpeg -i input.mp4 -vf select='eq(pict_type,I)' -vsync vfr keyframes_%03d.png
常用参数说明
-i：输入文件

-c:v / -c:a：指定视频/音频编码器（如 libx264, aac）

-copy：直接复制流（不重新编码）

-ss：起始时间

-t：持续时间

-vf：视频滤镜（如缩放、裁剪）

进阶技巧
硬件加速（如NVIDIA）：

bash
复制
ffmpeg -hwaccel cuda -i input.mp4 -c:v h264_nvenc output.mp4
生成GIF：

bash
复制
ffmpeg -i input.mp4 -vf "fps=10,scale=640:-1" output.gif
根据需求调整参数，使用 ffmpeg -h 或查阅官方文档获取更多细节
*/